import { render } from "./AboutUs.vue?vue&type=template&id=61d9904e"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=61d9904e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__